module.exports = function() {
  return new Worker(__webpack_public_path__ + "a05db7965e14529bb0ff.worker.js");
};